<script setup lang='ts'>
import { ref, Ref } from 'vue'
import { DEFAULT_CONFIG, useConfig } from '@/config/useConfig'
import { until, useAsyncState } from '@vueuse/core'
import { SamlConfig } from '@/types/interfaces'

declare global {
  const saml: any
}

// Provider Settings
const componentState: Ref<SamlConfig> = ref(DEFAULT_CONFIG.value.saml)

const props = defineProps(['isSubmitting'])
const { state, isReady } = useAsyncState(
  useConfig(),
  DEFAULT_CONFIG.value
);
(async () => {
  await until(isReady).toBe(true)
  componentState.value = state.value.saml
})()

const emit = defineEmits(['samlLogin'])
</script>
<template>
  <div v-if='componentState.loginActive === true || componentState.loginActive === "true"' id='buttonDiv' class="btnSaml">
    <lp-button id='btnSaml' class='saml-button w-100 btn-loading-active' :loading="props.isSubmitting">Sign In with {{
      componentState.providerName }}</lp-button>
  </div>
</template>
<style>
#btnSaml.saml-button {
  background: v-bind("componentState.providerPalette.background.main");
  text-align: center;
  color: v-bind(componentState.providerPalette.color);
  border: v-bind(componentState.providerPalette.border);
  background-repeat: no-repeat !important;
  background-position: top 50% left 10px !important;
  background-image: v-bind(`url(${componentState.providerLogo})`);
  padding: 0 2rem;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: all .3s;
  background-size: 25px 25px;
  height: 40px;
}

#btnSaml.saml-button:hover {
  background-color: v-bind(componentState.providerPalette.background.hover);
  transition: all .3s;
}

#btnSaml.saml-button-intuit {
  background-size: 40px 25px;
}

.btnSaml .lp-loading .lp-loading-circle {
  stroke: v-bind(componentState.providerPalette.color);
}
</style>
